module.exports = __webpack_public_path__ + "static/media/5ed7b16172f4e5e57a748795.b8be768d.png";